import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import * as _ from 'lodash';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Building } from 'src/app/models';
import { BuildingsService } from 'src/app/services/buildings.service';

@Component({
  selector: 'app-buildings',
  templateUrl: './buildings.component.html',
  styles: [``],
})
export class BuildingsComponent implements OnInit {
  public filterValue$: Observable<string>;
  public gridData$: Observable<GridDataResult>;
  public loaded$: Observable<boolean>;
  public pageSize = 40;
  public rowHeight = 30;
  public skip$ = new BehaviorSubject<number>(0);
  public sort$ = new BehaviorSubject<SortDescriptor[]>([
    {
      field: 'name',
      dir: 'asc',
    },
  ]);
  constructor(
    public dialog: MatDialog,
    private buildingsService: BuildingsService,
  ) {}

  ngOnInit() {
    this.loaded$ = this.buildingsService.loaded$;
    this.filterValue$ = this.buildingsService.filter$;

    this.gridData$ = combineLatest(this.buildingsService.filteredEntities$, this.sort$, this.skip$).pipe(
      map(([buildings, [sort], skip]) => {
        const data = sort.dir === 'asc' ? _.sortBy(buildings, sort.field) : _.sortBy(buildings, sort.field).reverse();

        const pagedData = data.slice(skip, skip + this.pageSize);
        return { data: pagedData, total: data.length };
      }),
    );
  }

  openNewDialog() {
    this.buildingsService.openNewDialog().subscribe();
  }
  openEditDialog(building: Building) {
    this.buildingsService.openEditDialog(building).subscribe();
  }

  delete(building: Building) {
    this.buildingsService.delete(building);
  }
  filterBuildings(filter) {
    this.buildingsService.setFilter(filter);
  }
  public sortChange(sort: SortDescriptor[]) {
    this.sort$.next(sort);
  }

  public pageChange(event: PageChangeEvent) {
    this.skip$.next(event.skip);
  }
}
